// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as AcademyFragments$LiteracyplanetClientSxEntry from "./AcademyFragments.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyIndexQuery($yearLevel: LearningLevelEnum!, $locale: Locale!)  {\nfindDefaultMenuNodesByLevel(level: $yearLevel, locale: $locale)  {\n...MenuFragment   \n}\n\nfindStrandsByLevel(level: $yearLevel, locale: $locale)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse(value) {
  var value$1 = value.findDefaultMenuNodesByLevel;
  var value$2 = value.findStrandsByLevel;
  return {
          findDefaultMenuNodesByLevel: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findStrandsByLevel: value$2.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$2 = value.findDefaultMenuNodesByLevel;
  var findDefaultMenuNodesByLevel = value$2.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findDefaultMenuNodesByLevel: findDefaultMenuNodesByLevel,
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables(yearLevel, locale, param) {
  return {
          yearLevel: yearLevel,
          locale: locale
        };
}

var IndexQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var IndexQuery = {
  IndexQuery_inner: IndexQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var IQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var Raw$1 = {};

var query$1 = GraphqlTag.gql([
      "query AcademyMenuQuery($id: ID!, $yearLevel: LearningLevelEnum!, $locale: Locale!)  {\nfindMenuNodesByParentId(id: $id, locale: $locale)  {\n...MenuFragment   \n}\n\nfindBreadCrumb(id: $id, locale: $locale)  {\n...MenuFragment   \n}\n\nfindStrandsByLevel(level: $yearLevel, locale: $locale)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse$1(value) {
  var value$1 = value.findMenuNodesByParentId;
  var value$2 = value.findBreadCrumb;
  var value$3 = value.findStrandsByLevel;
  return {
          findMenuNodesByParentId: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findBreadCrumb: value$2.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findStrandsByLevel: value$3.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize$1(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$2 = value.findBreadCrumb;
  var findBreadCrumb = value$2.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$3 = value.findMenuNodesByParentId;
  var findMenuNodesByParentId = value$3.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findMenuNodesByParentId: findMenuNodesByParentId,
          findBreadCrumb: findBreadCrumb,
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables$1(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          id: inp.id,
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables$1(id, yearLevel, locale, param) {
  return {
          id: id,
          yearLevel: yearLevel,
          locale: locale
        };
}

var MenuQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useFetch$1 = include$1.useFetch;

var MenuQuery = {
  MenuQuery_inner: MenuQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useFetch: useFetch$1
};

var MQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useFetch: useFetch$1
    });

function partition(m) {
  return Belt_Array.reduce(m, [
                [
                  [],
                  [],
                  [],
                  []
                ],
                0
              ], (function (param, curr) {
                  var i = param[1];
                  var a = param[0];
                  var i$1 = i === 3 ? 0 : i + 1 | 0;
                  var arr = a[i$1];
                  var newArr = Belt_Array.concat(arr, [curr]);
                  a[i$1] = newArr;
                  return [
                          a,
                          i$1
                        ];
                }))[0];
}

function handleIndexResponse(res) {
  return {
          TAG: "AcademyMenu",
          _0: {
            strands: res.findStrandsByLevel,
            categories: partition(res.findDefaultMenuNodesByLevel),
            breadcrumb: []
          }
        };
}

function onIndexResult(query) {
  return Belt_Result.map(query, handleIndexResponse);
}

function onLoading(param) {
  return "LoadingAcademyMenu";
}

function useIndex(yearLevel) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  return Curry._4(IQ.useWithErrorModal, onLoading, onLoading, onIndexResult, {
              yearLevel: yearLevel,
              locale: locale
            });
}

function handleMenuResponse(res) {
  return {
          TAG: "AcademyMenu",
          _0: {
            strands: res.findStrandsByLevel,
            categories: partition(res.findMenuNodesByParentId),
            breadcrumb: res.findBreadCrumb
          }
        };
}

function onMenuesult(query) {
  return Belt_Result.map(query, handleMenuResponse);
}

function useMenu(id, yearLevel) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  return Curry._4(MQ.useWithErrorModal, onLoading, onLoading, onMenuesult, {
              id: id,
              yearLevel: yearLevel,
              locale: locale
            });
}

var MenuFragment;

export {
  MenuFragment ,
  IndexQuery ,
  IQ ,
  MenuQuery ,
  MQ ,
  partition ,
  handleIndexResponse ,
  onIndexResult ,
  onLoading ,
  useIndex ,
  handleMenuResponse ,
  onMenuesult ,
  useMenu ,
}
/* query Not a pure module */
